'use strict';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var MapGenerator = require('./map-generator');
var stringify = require('./stringify');
var warnOnce = require('./warn-once');
var parse = require('./parse');
var Result = require('./result');
var NoWorkResult = /*#__PURE__*/function (_Symbol$toStringTag) {
  function NoWorkResult(processor, css, opts) {
    _classCallCheck(this, NoWorkResult);
    css = css.toString();
    this.stringified = false;
    this._processor = processor;
    this._css = css;
    this._opts = opts;
    this._map = undefined;
    var root;
    var str = stringify;
    this.result = new Result(this._processor, root, this._opts);
    this.result.css = css;
    var self = this;
    Object.defineProperty(this.result, 'root', {
      get: function get() {
        return self.root;
      }
    });
    var map = new MapGenerator(str, root, this._opts, css);
    if (map.isMap()) {
      var _map$generate3 = map.generate(),
        _map$generate4 = _slicedToArray(_map$generate3, 2),
        generatedCSS = _map$generate4[0],
        generatedMap = _map$generate4[1];
      if (generatedCSS) {
        this.result.css = generatedCSS;
      }
      if (generatedMap) {
        this.result.map = generatedMap;
      }
    }
  }
  return _createClass(NoWorkResult, [{
    key: _Symbol$toStringTag,
    get: function get() {
      return 'NoWorkResult';
    }
  }, {
    key: "processor",
    get: function get() {
      return this.result.processor;
    }
  }, {
    key: "opts",
    get: function get() {
      return this.result.opts;
    }
  }, {
    key: "css",
    get: function get() {
      return this.result.css;
    }
  }, {
    key: "content",
    get: function get() {
      return this.result.css;
    }
  }, {
    key: "map",
    get: function get() {
      return this.result.map;
    }
  }, {
    key: "root",
    get: function get() {
      if (this._root) {
        return this._root;
      }
      var root;
      var parser = parse;
      try {
        root = parser(this._css, this._opts);
      } catch (error) {
        this.error = error;
      }
      if (this.error) {
        throw this.error;
      } else {
        this._root = root;
        return root;
      }
    }
  }, {
    key: "messages",
    get: function get() {
      return [];
    }
  }, {
    key: "warnings",
    value: function warnings() {
      return [];
    }
  }, {
    key: "toString",
    value: function toString() {
      return this._css;
    }
  }, {
    key: "then",
    value: function then(onFulfilled, onRejected) {
      if (process.env.NODE_ENV !== 'production') {
        if (!('from' in this._opts)) {
          warnOnce('Without `from` option PostCSS could generate wrong source map ' + 'and will not find Browserslist config. Set it to CSS file path ' + 'or to `undefined` to prevent this warning.');
        }
      }
      return this.async().then(onFulfilled, onRejected);
    }
  }, {
    key: "catch",
    value: function _catch(onRejected) {
      return this.async().catch(onRejected);
    }
  }, {
    key: "finally",
    value: function _finally(onFinally) {
      return this.async().then(onFinally, onFinally);
    }
  }, {
    key: "async",
    value: function async() {
      if (this.error) return Promise.reject(this.error);
      return Promise.resolve(this.result);
    }
  }, {
    key: "sync",
    value: function sync() {
      if (this.error) throw this.error;
      return this.result;
    }
  }]);
}(Symbol.toStringTag);
module.exports = NoWorkResult;
NoWorkResult.default = NoWorkResult;